import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import CmRenovAI from "@/pages/CmRenovAI";
import AuthPage from "@/pages/AuthPage";
import MonEspace from "@/pages/MonEspace";
import AdminPage from "@/pages/AdminPage";
import SharePage from "@/pages/SharePage";
import RealisationsPage from "@/pages/RealisationsPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import { AuthProvider } from "@/context/AuthContext";

function App() {
    useEffect(() => {
        const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("in"); });
        }, { threshold: 0.12 });
        document.querySelectorAll(".section-fade").forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, []);

    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/mentions-legales" element={<LegalPage />} />
                        <Route path="/cmrenov-ai" element={<CmRenovAI />} />
                        <Route path="/connexion" element={<AuthPage />} />
                        <Route path="/mon-espace" element={<MonEspace />} />
                        <Route path="/admin" element={<AdminPage />} />
                        <Route path="/partage/:shareId" element={<SharePage />} />
                        <Route path="/realisations" element={<RealisationsPage />} />
                        <Route path="/payment/success" element={<PaymentSuccess />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
            <Toaster
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#1C1E1D", color: "#FAF9F6",
                        border: "1px solid #B89C6A", borderRadius: 0,
                        fontFamily: "Manrope, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
